import { logout } from '../../../actions/userActions';
import Loading from '../../common/Loading';
import { useEffect } from 'react';
import { connect } from 'react-redux';

const LogoutRedirect = ({ logout, sessionId }) => {
  useEffect(() => {
    if (sessionId !== null) {
      logout();
    }
  }, [logout, sessionId]);

  return <Loading text="Logging out..." />;
};

const mapStateToProps = (state) => ({
  sessionId: state.user.sessionId,
});

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutRedirect);
